import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { authActions } from "../../redux/actions";
import FormOne from "./components/FormOne";
import FormTwo from "./components/FormTwo";
import { Link } from "react-router-dom";
import noqLogoNew from "../../assets/icons/NO-QLogo-new.svg";
import PrimaryButton from "../../assets/components/PrimaryButton";

const Signup = () => {
    const [currentPage, setCurrentPage] = useState("createAccount");
    const [activeStep, setActiveStep] = useState(0);
    const [formData, setFormData] = useState({
        name: "",
        type: "",
        email: "",
        phone_number: "",
        street: "",
        city: "",
        postal_code: "",
        services: "",
        logo: null,
        user: {
            first_name: "",
            last_name: "",
            email: "",
            password: "",
            confirm_password: "",
            phone_number: "",
        },
    });

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { isSignUpInSuccess, isSigningUp } = useSelector((state) => state.auth);

    const showSignUpForm = () => setCurrentPage("signUpForm");

    const handleNext = useCallback(() => {
        if (activeStep === 1) {
            const formBody = new FormData();
            Object.keys(formData).forEach((key) => {
                if (typeof formData[key] === "object" && key !== "logo") {
                    Object.keys(formData[key]).forEach((nestedKey) => {
                        formBody.append(`${key}[${nestedKey}]`, formData[key][nestedKey]);
                    });
                } else {
                    if (formData[key]) {
                        formBody.append(key, formData[key]);
                    }
                }
            });

            const { user, ...rest } = formData;
            const { confirm_password, ...others } = user;

            return dispatch(authActions.signup(formBody));
        }
        setActiveStep((prevState) => prevState + 1);
    }, [activeStep, dispatch, formData]);
    // console.log("formData", formData);
    const handleBack = useCallback(() => {
        if (activeStep === 1) {
            return setActiveStep((prevState) => prevState - 1);
        }
        return navigate("/login");
    }, [activeStep, navigate]);

    const displayActiveForm = () => {
        switch (activeStep) {
            case 0:
                return (
                    <FormOne
                        formData={formData}
                        setFormData={setFormData}
                        handleBack={handleBack}
                    />
                );

            case 1:
                return (
                    <FormTwo
                        formData={formData}
                        setFormData={setFormData}
                        handleBack={handleBack}
                        isSigningUp={isSigningUp}
                    />
                );

            default:
                return (
                    <FormOne
                        formData={formData}
                        setFormData={setFormData}
                        handleBack={handleBack}
                    />
                );
        }
    };

    useEffect(() => {
        if (isSignUpInSuccess) {
            navigate("/login");
            dispatch(authActions.resetSignUpSuccess());
        }
    }, [dispatch, navigate, isSignUpInSuccess]);

    return (
        <div className="font-sans">
            {currentPage === "createAccount" && (
                <div className="bg-background-dark min-h-screen relative px-4">
                    <img
                        src={noqLogoNew}
                        alt="NO-Q"
                        className="absolute top-8 left-8 w-24 max-sm:w-20"
                    />

                    <div className="min-h-screen flex flex-col items-center justify-center text-white">
                        <div className="w-full max-w-[540px] text-center">
                            <h1 className="text-4xl sm:text-5xl font-bold mb-8">Join No-Q</h1>

                            <PrimaryButton onClick={showSignUpForm} className="w-full">
                                Join No-Q
                            </PrimaryButton>

                            <p className="text-sm mt-6">
                                By Creating an account, you agree to the{" "}
                                <a
                                    href={"/Docs"}
                                    className="underline"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Terms of Service
                                </a>{" "}
                                and{" "}
                                <a
                                    href={"/Docs#privacy"}
                                    className="underline"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Privacy Policy
                                </a>
                                , including{" "}
                                <a
                                    href={"/Docs#cookies"}
                                    className="underline"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Cookie Use
                                </a>
                                .
                            </p>
                        </div>

                        <p className="absolute bottom-8 w-full text-center text-sm">
                            Have an account already?{" "}
                            <Link className="underline font-semibold" to={"/login"}>
                                Log in here
                            </Link>
                        </p>
                    </div>
                </div>
            )}

            {currentPage === "signUpForm" && (
                <div className="bg-background-dark min-h-screen relative px-4 py-24">
                    <img
                        src={noqLogoNew}
                        alt="NO-Q"
                        className="absolute top-8 left-8 w-24 max-sm:w-20"
                    />

                    <div className="flex flex-col items-center text-white">
                        <h1 className="text-4xl sm:text-5xl font-bold text-center mb-10">
                            Create an Account
                        </h1>

                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleNext();
                            }}
                            className="w-full flex justify-center"
                        >
                            {displayActiveForm()}
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Signup;
